import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
export const BoardBottombar = /*#__PURE__*/ memo((param)=>{
    let { className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: tailwindMerge("sticky inset-x-0 bottom-0 z-30 flex h-12 w-full items-center justify-between bg-grey-1/85 px-4 backdrop-blur-[18px]", className),
        ...restOfProps
    });
});
BoardBottombar.displayName = "BoardBottombar";
